export default "__VITE_ASSET__CHPTSDxW__"